<template>
  <b-modal
    ref="add-contact"
    :visible="showModal"
    hide-header
    centered
    size="md"
    :ok-title="$t('actions.submit')"
    :cancel-title="$t('actions.cancel')"
    @ok="updatePassword"
    @hidden="closeModal"
  >
    <div v-if="!loading">
      <b-form-group :label="$t('field.password')">
        <b-form-input
          v-model="$v.password.$model"
          :class="{ 'border border-danger rounded': $v.password.$error }"
          name="password"
          type="password"
          placeholder="********"
        />
      </b-form-group>
      <b-form-group :label="$t('field.new_password')">
        <b-form-input
          v-model="$v.newPassword.$model"
          :class="{ 'border border-danger rounded': $v.newPassword.$error }"
          name="newPassword"
          type="password"
          placeholder="********"
        />
        <li class="text-danger list-group-item px-0 border-0 py-0">
          <span v-if="!$v.newPassword.minLength" class="small text-danger">{{
            $t("form.min_length", { min: 8 })
          }}</span>
        </li>
      </b-form-group>
      <b-form-group :label="$t('field.password_confirmation')">
        <b-form-input
          v-model="$v.newPasswordConfirmation.$model"
          :class="{
            'border border-danger rounded': $v.newPasswordConfirmation.$error,
          }"
          name="newPasswordConfirmation"
          type="password"
          placeholder="********"
        />
        <li class="text-danger list-group-item px-0 border-0 py-0">
          <span
            v-if="
              !$v.newPasswordConfirmation.sameAs &&
              $v.newPasswordConfirmation.$error
            "
            class="small text-danger"
            >{{
              $t("form.sameAs", {
                field: this.$t("field.password").toLowerCase(),
              })
            }}</span
          >
        </li>
      </b-form-group>
    </div>
    <div v-else>
      <spinner />
    </div>
  </b-modal>
</template>
<script>
import api from '@/api/users'
import { minLength, sameAs, requiredIf } from 'vuelidate/lib/validators'

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    api,
    data: [],
    loading: true,
    password: null,
    newPassword: null,
    newPasswordConfirmation: null,
    companies: []
  }),
  created() {
    this.init()
  },
  methods: {
    init() {
      this.data = this.item
      this.data['role'] = this.item.roles[0].name

      Object.keys(this.data.companies).map(company => {
        this.companies.push(this.data.companies[company].id)
      })

      this.loading = false
    },
    closeModal() {
      this.$emit('close')
      this.password = null
      this.newPassword = null
      this.newPasswordConfirmation = null
    },
    async updatePassword(modalEvt) {
      this.loading = true

      this.$v.$touch()
      modalEvt.preventDefault()

      if (this.$v.$invalid) {
        this.$toasted.error(this.$t('form.error'))
        this.loading = false
        return
      } else {
        const newData = {
          ...this.data,
          ...{ old_password: this.password },
          ...{ password: this.newPassword },
          ...{ password_confirmation: this.newPasswordConfirmation },
          ...{ companies: this.companies.join() }
        }

        try {
          const response = await this.api.update({ ...newData }, this.item.id)

          if (response && response.data) {
            this.$toasted.success(
              this.$t('messages.updated', { item: 'Utilizador' })
            )

            this.closeModal()
          } else if (
            response &&
            response.response &&
            response.response.data &&
            response.response.data.errors
          ) {
            this.$toasted.error(
              this.$t(Object.values(response.response.data.errors).join(' '))
            )
          } else {
            this.$toasted.error(this.$t('messages.unknown_error'))
          }
        } catch (e) {
          console.error(e)
        }
        this.loading = false
      }
    }
  },
  validations: {
    password: {
      required: requiredIf('newPassword', minLength(1))
    },
    newPassword: {
      minLength: minLength(8),
      required: requiredIf('newPasswordConfirmation', minLength(1))
    },
    newPasswordConfirmation: {
      sameAsPassword: sameAs('newPassword')
    }
  }
}
</script>

